export default __webpack_public_path__ + "static/media/icono_telefono.21946f24.svg";